import type { AnalyticsVaultVersion, ExposureTab } from '../events'
import { trackAnalyticsEvent } from '../track'

interface TrackExposureRowClickedParams {
  sourceVaultAddress: string
  sourceVaultVersion: AnalyticsVaultVersion
  sourceChainId: number
  destinationType: 'market' | 'vault'
  destinationIdentifier: string
  destinationChainId: number
  tab?: 'vaults_and_markets'
}

export function trackExposureRowClicked(params: TrackExposureRowClickedParams) {
  trackAnalyticsEvent('exposure_row_clicked', {
    source_vault_address: params.sourceVaultAddress,
    source_vault_version: params.sourceVaultVersion,
    source_chain_id: params.sourceChainId,
    destination_type: params.destinationType,
    destination_identifier: params.destinationIdentifier,
    destination_chain_id: params.destinationChainId,
    ...(params.tab ? { tab: params.tab } : {})
  })
}

interface TrackExposureTabChangedParams {
  tab: ExposureTab
  vaultAddress: string
  chainId: number
}

/**
 * Fired when a user switches the Vault V2 Allocation → Exposure pill. Usage per
 * view is `exposure_tab_changed` broken down by `tab`.
 */
export function trackExposureTabChanged({
  tab,
  vaultAddress,
  chainId
}: TrackExposureTabChangedParams) {
  trackAnalyticsEvent('exposure_tab_changed', {
    page: 'vault',
    tab,
    vault_address: vaultAddress.toLowerCase(),
    chain_id: chainId
  })
}
